module.exports = __webpack_public_path__ + "static/media/emtyNotificationIcon.2849083f.svg";